import React, { useState, useEffect, useContext } from 'react';
import './Result.css';
import AuthContext from '../../contexts/AuthContext';
import AuthService from '../../services/AuthService';


const Result = ({ topicId, type_ = 'exercise', totalQuestions, correctAnswers, onBackToTopic, onRetry }) => {
    const { user, setUser } = useContext(AuthContext); // Assuming AuthContext provides `setUser` to update user data
    const [scorePercentage, setScorePercentage] = useState(0);
    const [resultMessage, setResultMessage] = useState('');
    const [expGained, setExpGained] = useState(null);

    const calculateScore = () => {
        const percentage = Math.ceil((correctAnswers / totalQuestions) * 100);
        setScorePercentage(percentage);
        return percentage;
    };

    const updateExpAndLevel = async (gainedExp) => {
        if (!user) return;

        try {
            const response = await fetch('/api/userdata/updateExp', {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    gainedExp,
                }),
            });

            if (response.ok) {
                const { level, exp, expRequired } = await response.json();
                setUser({
                    ...user,
                    level: level,
                    exp: exp,
                    expRequired: expRequired
                });
            }
        } catch (error) {
            console.error('Error updating EXP:', error);
        }
    };

    useEffect(() => {
        const percentage = calculateScore();
        const passingScore = 70; // Define the passing score threshold

        if (percentage >= passingScore) {
            setResultMessage('Congratulations! You passed! 🎉');

            const inLearned = user.topicStatus.learned.includes(parseInt(topicId));
            const inMaybe = user.topicStatus.maybe.includes(parseInt(topicId));
            const expReward = 10; // TODO amount of exp depends on difficulty

            // Only update the level and exp if user have not completed the exercise or test previously
            if (type_ === 'exercise'){
                if (!inMaybe && !inLearned) {
                    setProgress('maybe');
                    setExpGained(expReward);
                    updateExpAndLevel(expReward);
                }
            } else if (type_ === 'test') {
                if (!inLearned) {
                    setProgress('learned');
                    setExpGained(expReward);
                    updateExpAndLevel(expReward);
                }
            }

        } else {
            setResultMessage('Don’t give up! Keep practicing and try again.');
        }
    }, []);

    const setProgress = async (selectedProgress) => {
        if (!user) return;

        const response = await fetch('/api/topic/setProgress', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                topicID: topicId,
                userID: user.userProfileId,
                status: selectedProgress,
            }),
        });

        if (response.ok) {
            const res = await response.json();
            if (user.topicStatus) {
                user.topicStatus = res.data.topicStatus;
            }
            AuthService.syncLocalUserSession(user);
        }
    };

    return (
        <div className="result-container">
            <h1>{`You answered ${correctAnswers} out of ${totalQuestions} correctly.`}</h1>
            <h2 className="result-message">{resultMessage}</h2>

            {scorePercentage >= 90 && (
                <>
                    {expGained && (
                        <>
                            <p>{`EXP Gained: ${expGained}`}</p>
                            {user && (
                                <p>
                                    {`New Level: ${user.level} | Current EXP: ${user.exp} / ${user.expRequired}`}
                                </p>
                            )}
                        </>
                    )}
                </>
            )}

            <div className="result-buttons">
                {scorePercentage < 90 ? (
                    <>
                        <button className="btn btn-primary" onClick={onRetry}>
                            Retry
                        </button>
                        <button className="btn btn-secondary" onClick={onBackToTopic}>
                            Back to Topic
                        </button>
                    </>
                ) : (
                    <button className="btn btn-primary" onClick={onBackToTopic}>
                        Back to Topic
                    </button>
                )}
            </div>
        </div>
    );
};

export default Result;
